import { insertImage } from './operations';

const slashMenu = {
  Image: { icon: 'image', basic: true, transform: insertImage },
};

export default slashMenu;
